import clsx from 'clsx';
import { h, Fragment } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import Backdrop from './backdrop';

const Panel = ({
  children,
  alignment = 'right',
  context = null,
  triggers = {},
  defaultOpen = false,
  additionalClasses = '',
  showBackdrop = false,
  instantOpen = false,
}) => {
  const { openTriggerEl, closeTriggerEl, toggleEl, openTriggerElSticky } =
    triggers;
  const [isOpen, setIsOpen] = useState(instantOpen || defaultOpen);
  const handleOpenEvent = (e) => {
    e.preventDefault();
    e.stopPropagation();
    document.querySelector('body').classList.add('disable-scroll');
    document.querySelector('html').classList.add('disable-scroll');
    setIsOpen(true);
  };
  const handleCloseEvent = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsOpen(false);
    document.querySelector('body').classList.remove('disable-scroll');
    document.querySelector('html').classList.remove('disable-scroll');
  };
  const handleToggleEvent = () => setIsOpen(!isOpen);

  useEffect(() => {
    if (openTriggerEl) openTriggerEl.addEventListener('click', handleOpenEvent);
    if (openTriggerElSticky)
      openTriggerElSticky.addEventListener('click', handleOpenEvent);
    if (closeTriggerEl)
      closeTriggerEl.addEventListener('click', handleCloseEvent);
    if (toggleEl) toggleEl.addEventListener('click', handleToggleEvent);
    if (context) {
      document.addEventListener(`${context}:open`, handleOpenEvent);
      document.addEventListener(`${context}:close`, handleCloseEvent);
    }

    return () => {
      if (openTriggerEl)
        openTriggerEl.removeEventListener('click', handleOpenEvent);
      if (closeTriggerEl)
        closeTriggerEl.removeEventListener('click', handleCloseEvent);
      if (toggleEl) toggleEl.removeEventListener('click', handleToggleEvent);
      if (context) {
        document.removeEventListener(`${context}:open`, handleOpenEvent);
        document.removeEventListener(`${context}:close`, handleCloseEvent);
      }
    };
  }, [openTriggerEl, closeTriggerEl, toggleEl, openTriggerElSticky]);

  const closedClass =
    alignment === 'right' ? 'translate-x-full' : '-translate-x-full';

  return (
    <>
      {showBackdrop && isOpen && (
        <Backdrop isOpen={isOpen} setIsOpen={setIsOpen} context={context} />
      )}
      <div
        className={clsx(
          'max-w-panel h-full fixed top-0 bottom-0 transition-transform z-[41] bg-white scrollbar-hide',
          alignment === 'right' ? 'right-0' : 'left-0',
          isOpen ? 'translate-x-0 w-full' : closedClass,
          instantOpen && '!translate-x-0 w-full',
          additionalClasses,
        )}
      >
        {(isOpen || instantOpen) && children}
      </div>
    </>
  );
};

export default Panel;
